import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ElementsInputObj, GenericResModel, LetterDeleteReqInterface, LetterS3Model } from 'countable@model';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { LetterContentReqInterface } from '../model/letter/letter-content-req.interface';
import { ShareReqInterface } from '../model/letter/share-req.interface';
import { UpdateTemplateContentInterface } from '../model/letter/update-template-content.interface';
import { AuthService } from './auth.service';


@Injectable({
  providedIn: 'root'
})

export class EngLetterService {

  constructor(public authService: AuthService, private http: HttpClient) { }

  getUserDetails() {
    return this.authService.getUserDetail();
  }

  getEngagementDetails() {
    return JSON.parse((localStorage.getItem('selectedEngagementObj')));
  }

  getUserId(): number {
    return this.getUserDetails().useracctid;
  }

  getClientFirmId(): number {
    return this.getEngagementDetails().clientfirmid;
  }

  getEngagementId(): number {
    return this.getEngagementDetails().engagementsid;
  }

  getClientEngId(): number {
    return +(localStorage.getItem('engagementID'));
  }

  getClientEngObj() {
    return JSON.parse(localStorage.getItem('selectedClientEngagementObj'));
  }

  getClientPortalFirmId(): number {
    return this.getClientEngObj().clientfirmid;
  }

  isReviewEngagement(): boolean {
    return this.getEngagementDetails().pengagementtypeid === 2
  }

  getAutomatedElementsInput(origin: 'firm' | 'client'): ElementsInputObj {
    const inputObj: ElementsInputObj = new ElementsInputObj();
    inputObj.clientFirmId = origin === 'firm' ? this.getClientFirmId() : this.getClientPortalFirmId();
    inputObj.engagementId = origin === 'firm' ? this.getEngagementId() : this.getClientEngId();
    inputObj.loginId = this.getUserId();
    inputObj.firmHash = this.firmHash();
    return inputObj;
  }

  public clientFirmId = (): number => { return this.engagementDetails() ? +(this.engagementDetails()?.clientfirmid) : 0; };

  public engagementDetails = (): any => { return JSON.parse((localStorage.getItem('selectedEngagementObj'))); };

  public firmHash = (): string => { return localStorage.getItem('firm-hash'); };

  public getEngTyepId = (): number => {
    const engInfo = structuredClone(this.getEngagementDetails());
    return engInfo?.pengagementtypeid ? engInfo?.pengagementtypeid :
      (engInfo?.engagementtypeid ? engInfo?.engagementtypeid : 0);
  };

  public updateTemplateValiditiyByEngTypeId(templateEngTypeId: number = 0) {
    if (templateEngTypeId === 0) {
      return false;
    }
    switch (this.getEngTyepId()) {
      case 1:
        return ![1, 34, 35, 36, 37].includes(templateEngTypeId);
      case 2:
        return ![2, 34, 35, 36, 37].includes(templateEngTypeId);
      case 34:
      case 35:
      case 36:
      case 37:
        return ![1, 34, 35, 36, 37].includes(templateEngTypeId);
      default:
        return true;
    }
  }

  public deleteLetterBySection(request: LetterDeleteReqInterface): Observable<GenericResModel<boolean>> {
    return this.http.delete<GenericResModel<boolean>>(environment.apiV2 + `/eng-section/letter/template`, {
      body: request
    });
  }

  public fetchLetterContent(request: LetterContentReqInterface): Observable<GenericResModel<LetterS3Model>> {
    const url = environment.apiV2 + `/eng-section/letter/content`;
    return this.http.post<GenericResModel<LetterS3Model>>(url, request);
  }

  public updateLetterContent(request: Partial<UpdateTemplateContentInterface>): Observable<GenericResModel<boolean>> {
    const url = environment.apiV2 + `/eng-section/letter/content`;
    return this.http.put<GenericResModel<boolean>>(url, request);
  }

  public updateLetterTemplate(engId: number, formData: FormData): Observable<GenericResModel<boolean>> {
    const url = environment.apiV2 + `/eng-section/letter/content/${engId}`;
    return this.http.post<GenericResModel<boolean>>(url, formData);
  }

  public shareWithClient(input: ShareReqInterface): Observable<GenericResModel<boolean>> {
    const url = environment.apiV2 + `/eng-section/letter/share`;
    return this.http.post<GenericResModel<boolean>>(url, input);
  }

  public reShareWithClient(input: ShareReqInterface): Observable<GenericResModel<boolean>> {
    const url = environment.apiV2 + `/eng-section/letter/share`;
    return this.http.put<GenericResModel<boolean>>(url, input);
  }
}
